import { Component, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { LocationPickerComponent } from '../location-picker';
import { SheetComponent } from '../sheet';

@Component({
    selector: 'location-picker-sheet',
    template: require('./location-picker-sheet.component.pug')
})
export class LocationPickerSheetComponent {
    @Input() showLocations: boolean = true;
    @Output() applyChanges = new EventEmitter();

    @ViewChild(SheetComponent) sheetComponent;
    @ViewChild(LocationPickerComponent) locationPickerComponent;

    toggle() {
        this.sheetComponent.toggle();
    }

    onApplyClicked() {
        let form = this.locationPickerComponent.fg;

        if (form.valid) {
            let selection = this.locationPickerComponent.getSelection();
            this.applyChanges.emit(selection);
        }

    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/ui/location-picker-sheet/location-picker-sheet.component.ts